export enum MimeTypes {
  APK = 'application/vnd.android.package-archive',
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  PDF = 'application/pdf',
}
